<template>
  <div class="content-summary">
    <div class="summary-title">Summary</div>
    <div class="summary-group">
      <div
        v-for="(value, key) in summary.stats"
        :key="key"
        class="summary-elem"
      >
        <div class="summary-days">{{ `${value.amt} Days` }}</div>
        <div style="text-transform:uppercase">{{ value.text }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: Array
  },
  watch: {
    items: {
      handler(n, prev) {
        this.reload();
      },
      deep: true
    }
  },
  mounted() {
    this.reload();
  },
  methods: {
    reload() {
      this.summary.stats = {
        'On Time': { amt: 0, text: 'On Time' },
        Late: { amt: 0, text: 'Late' },
        Sickness: { amt: 0, text: 'Sickness' },
        Excuse: { amt: 0, text: 'Excuse' },
        Absent: { amt: 0, text: 'Absent' },
        'Early Leave Before 2 PM': { amt: 0, text: 'Early Leave < 2 PM' },
        'Early Leave After 2 PM': { amt: 0, text: 'Early Leave > 2 PM' }
      };
      this.items.forEach(elem => {
        // add the stats
        let type = elem.t;
        if (this.summary.stats[type]) {
          this.summary.stats[type].amt++;
        }
      });
    }
  },
  data() {
    return {
      summary: { title: 'Sickness, Absence, Excused Request', stats: null },
      period: null
    };
  }
};
</script>

<style scoped>
.content-summary {
  display: flex;
  flex-flow: column;
  padding: 5px;
}
.period-title {
  font-size: 1em;
  color: rgb(43, 42, 42);
}
.summary-title {
  font-size: 0.9em;
  color: #203368;
  text-transform: uppercase;
  font-weight: bold;
}
.summary-days {
  font-size: 1.5em;
}
.summary-group {
  display: flex;
  justify-content: center;
}
.summary-elem {
  background-color: rgb(34, 52, 107);
  color: white;
  width: 300px;
  height: 100px;
  padding: 10px;
  border-radius: 0.3em;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
}
.summary-elem:nth-child(even) {
  margin: 0 10px;
}

@media screen and (max-width: 768px) {
  .summary-elem:nth-child(even) {
    margin: 0 0 10px 0;
  }
  .summary-elem:nth-child(odd) {
    margin: 0 0 10px 0;
  }
  .summary-elem {
    height: 50px;
    width: auto;
    flex: 1 1 auto;
  }
  .summary-group {
    flex-flow: column;
  }
  .summary-days {
    font-size: 1.1em;
  }
}
</style>
